import Vue from 'vue';

// Domain
import {
  ManageTrackingInvestorGoalStateManager,
} from '@/modules/flagship/investor-goal/investor_goal/domain/state/manage-tracking-investor-goal-state-manager';
import ManageTrackingInvestorGoalState
  from '@/modules/flagship/investor-goal/investor_goal/domain/state/manage-tracking-investor-goal-state';
import Injectable from '@/modules/shared/domain/di/injectable';
import Observer from '@/modules/shared/domain/observer/observer';

@Injectable()
class ManageTrackingInvestorGoalVueStateManager implements ManageTrackingInvestorGoalStateManager {
  private _state: ManageTrackingInvestorGoalState = Vue.observable<ManageTrackingInvestorGoalState>(
    new ManageTrackingInvestorGoalState(),
  );

  private readonly observers: Observer[] = [];

  get state(): ManageTrackingInvestorGoalState {
    return this._state;
  }

  set state(value: ManageTrackingInvestorGoalState) {
    this._state = value;
  }

  patch(state: Partial<ManageTrackingInvestorGoalState>) {
    type Keys = keyof ManageTrackingInvestorGoalState;
    Object.entries(state).forEach(([key, value]) => {
      const accessor = key as Keys;

      if (value !== undefined) {
        // eslint-disable-next-line
        // @ts-ignore @typescript-eslint/ban-ts-ignore
        this.state[accessor] = value;
      }
    });
  }

  notifyAll() {
    this.observers.forEach((observer) => observer.notify());
  }

  register(observer: Observer) {
    this.observers.push(observer);
  }
}

export default ManageTrackingInvestorGoalVueStateManager;
